import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dapp from './components/Dapp';
import TicTacToeGame from './components/TicTacToe';
import RockPaperScissorsGame from './components/RockPaperScissorsGame';
import CoinFlipGame from './components/CoinFlip';
import RiskGame from './components/Risk';
import MillGame from './components/Mill';
import DICYGame from './components/DICY';
import DICYAdmin from './components/DICYAdmin';
import PersonalSettings from './components/PersonalSettings';
import WalletDetails from './components/WalletDetails';
import BlogSection from './components/BlogSection';
import BlogPost from './components/BlogPost';
import GameRegistryAdmin from './components/GameRegistryAdmin';
import AddressAddModal from './components/AddressAddModal';
import './index.css';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        {/* Main sections */}
        <Route path="/" element={<Navigate to="/information" replace />} />
        <Route path="/information" element={<Dapp />} />
        <Route path="/1on1" element={<Dapp />} />
        <Route path="/1on1/:gameName" element={<Dapp />} />
        <Route path="/asymmetric" element={<Dapp />} />
        <Route path="/asymmetric/:gameName" element={<Dapp />} />

        {/* Direct game routes with gameID (existing functionality) */}
        <Route path="/1on1/TicTacToe/:gameID" element={<TicTacToeGame />} />
        <Route path="/1on1/RockPaperScissors/:gameID" element={<RockPaperScissorsGame />} />
        <Route path="/1on1/CoinFlip/:gameID" element={<CoinFlipGame />} />
        <Route path="/1on1/Risk/:gameID" element={<RiskGame />} />
        <Route path="/1on1/Mill/:gameID" element={<MillGame />} />
        <Route path="/asymmetric/DICY" element={<DICYGame />} />
        <Route path="/asymmetric/DICY/admin" element={<DICYAdmin />} />

        {/* Legacy routes for backward compatibility */}
        <Route path="/TicTacToe/:gameID" element={<TicTacToeGame />} />
        <Route path="/tictactoe/:gameID" element={<TicTacToeGame />} />
        <Route path="/RockPaperScissors/:gameID" element={<RockPaperScissorsGame />} />
        <Route path="/rockpaperscissors/:gameID" element={<RockPaperScissorsGame />} />
        <Route path="/CoinFlip/:gameID" element={<CoinFlipGame />} />
        <Route path="/coinflip/:gameID" element={<CoinFlipGame />} />
        <Route path="/Risk/:gameID" element={<RiskGame />} />
        <Route path="/risk/:gameID" element={<RiskGame />} />
        <Route path="/Mill/:gameID" element={<MillGame />} />
        <Route path="/mill/:gameID" element={<MillGame />} />
        <Route path="/DICY/:gameID" element={<DICYGame />} />
        <Route path="/dicy/:gameID" element={<DICYGame />} />

        {/* Blog routes */}
        <Route path="/blog" element={<BlogSection />} />
        <Route path="/blog/:slug" element={<BlogPost />} />

        {/* Utility routes */}
        <Route path="/settings" element={<PersonalSettings />} />
        <Route path="/wallet-details" element={<WalletDetails />} />
        <Route path="/address_add" element={<AddressAddModal />} />

        {/* Admin routes */}
        <Route path="/admin" element={<GameRegistryAdmin />} />
        <Route path="/admin/gameregistry" element={<GameRegistryAdmin />} />
      </Routes>
    </Router>
  </React.StrictMode>
);
